module.exports = __webpack_public_path__ + "media/开心.644ff69c.mp3";